import RendererTypesEnum from '~/modules/catalog/category/components/filters/renderer/RendererTypesEnum';
import type { FilterConfigInterface } from '~/modules/catalog/category/config/FiltersConfig';

export enum FilterTypeEnum {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  SWATCH_COLOR = 'swatch_color',
  YES_NO = 'yes_no'
}

/**
 * Override this to add/modify filters renderers and data
 *
 * @attrCode: Magento attribute code
 * @type: internal filter type
 * @component: filter renderer component
 * @disabled: flag to disable filter on the front; disabled filter will be not rendered
 */
export default function config(): FilterConfigInterface[] {
  return [
    {
      attrCode: 'price',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      attrCode: 'product_collection',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      attrCode: 'olfactory_collection_label_web',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      attrCode: 'scent',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      attrCode: 'capacity_bucket',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      attrCode: 'editorial',
      type: FilterTypeEnum.CHECKBOX,
      component: RendererTypesEnum.CHECKBOX
    }
  ];
}
